'use client';

import BASE_API_URL from '@/helpers/baseUrls';
import axios from 'axios';
import { signOut, useSession } from 'next-auth/react';

export const useRefreshToken = () => {
  const { data: session, update } = useSession();

  const refreshToken = async () => {
    // Check if session and refresh token exist
    if (!session || !session.refresh) {
      await signOut({ callbackUrl: `${process.env.NEXT_PUBLIC_NEXT_URL}/auth/login` });
      return null;
    }

    try {
      const res = await axios.post(`${BASE_API_URL}/auth/jwt/refresh/`, {
        refresh: session.refresh,
      });

      if (res.data && res.data.access) {
        let access = res.data.access;
        if (session) session.access = access;
        // Update the session with new token
        await update();
        return access;
      } else {
        // Invalid response format
        await signOut({ callbackUrl: `${process.env.NEXT_PUBLIC_NEXT_URL}/auth/login` });
        return null;
      }
    } catch (error) {
      // Any error during refresh should log the user out
      await signOut({ callbackUrl: `${process.env.NEXT_PUBLIC_NEXT_URL}/auth/login` });
      return null;
    }
  };
  return refreshToken;
};
